import { render, staticRenderFns } from "./DrawerInspecionarCamadas.vue?vue&type=template&id=571f0fe3&lang=pug"
import script from "./DrawerInspecionarCamadas.vue?vue&type=script&lang=js"
export * from "./DrawerInspecionarCamadas.vue?vue&type=script&lang=js"
import style0 from "./DrawerInspecionarCamadas.vue?vue&type=style&index=0&id=571f0fe3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports